// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tooltip_wrap .cont[data-v-352b55fb] {padding: 20px;}\n.div_seal+.div_seal[data-v-352b55fb] {margin-top: 5px;}\n.tbl_mark td[data-v-352b55fb]{vertical-align: top;}\n", ""]);
// Exports
module.exports = exports;
